import React from 'react'


const styles = {
  root: (size => ({
    width: `${size}px`,
    height: `${size}px`,
    display: 'inline-block',
    position: 'absolute',
    left: '20px',
  })),
  image: (size => ({
    maxWidth: '100%',
    maxHeight: '500px',
    width: `${size}px`,
    height: `${size}px`,
    objectFit: 'cover',
    borderRadius: '100%',
  })),
}


const Avatar = ({ image_url, size }) => (
  <div style={styles.root(size)}>
    <img style={styles.image(size)} src={image_url} alt={image_url} />
  </div>
)

export default Avatar



// WEBPACK FOOTER //
// ./src/components/BadgeHeroesComponents/Avatar/index.jsx